import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './createStore';

/**
 * Use throughout your app instead of plain `useDispatch` and `useSelector`
 * These hooks have the correct types for the store
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
